import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sharePostFacebook",
  "use": "sharePostFacebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sharePostFacebook\"><circle cx=\"16\" cy=\"16\" fill=\"#f6efeb\" r=\"16\" /><path d=\"m13.9 13.5v-1.5c0-2.3 1.6-4 3.7-4h2.4v2.9h-2.4c-.2 0-.6.4-.6 1v1.6h3v3h-3v7.3h-3v-7.3h-2.4v-3z\" fill=\"#9c7446\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol